module.exports = __webpack_public_path__ + "img/2400x900_Zeppelin-Baggerboerse_v2.adfc151d.jpg";